import { platformNewsItemSectionsEnum } from "helpers/enums";
import { paramsObject } from "helpers/system";
import React, { useEffect } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import List from "./list";
import Show from "./show";

export default function UserPlatformNews(props) {
    useEffect(() => {
        return () => props.clearParams("user-platform-news");
    }, []);

    const { match, location } = props;
    const { tab } = paramsObject(props.location.search);
    const rootUrl = `${match.path}/list`;
    return (
        <div className="page-content">
            <Switch location={location}>
                <Route
                    exact
                    path={`${match.path}/`}
                    render={() => <Redirect to={`${rootUrl}?tab=${platformNewsItemSectionsEnum.Updates}`} />}
                />
                <Route
                    exact
                    path={rootUrl}
                    render={() => <List {...props} tab={tab} nofilter transition="full" title="Новости платформы" />}
                />
                <Route path={`${rootUrl}/:id`} render={(rest) => <Show {...rest} />} />
            </Switch>
        </div>
    );
}
